import { path } from 'd3-path'
import pointer from './helpers/pointer.js'
import Symbol2d from '../2d.js'
import tipLock from './helpers/tip-lock.js'

export default class BoxArrow extends Symbol2d {

  static mixins = [tipLock]

  handles = [{
    // First handle `x` controls the arrow height, `y` controls the arrow width
    defaults: [.77, .34],
    constraints: (dimensions, handles) => {
      const minX = handles[1].coords[0]
      const minY = .25
      return [
        [minX, 1], [minY, .5]
      ]
    },
    cursor: 'all-scroll'
  }, {
    // Second handle `x` controls the box width
    defaults: [.57, 1],
    constraints: (dimensions, handles) => {
      // The max x value cannot exceed handles[0].coords[0]
      const maxX = handles[0].coords[0]
      return [
        [0, maxX], null
      ]
    },
    cursor: 'ew-resize'
  }]

  path (dimensions, handles) {
    const boxWidth = dimensions.width * handles[1][0]
    const _path = path()
    const _pointer = pointer(_path, dimensions, handles[0])

    _path.moveTo(boxWidth, 0)

    // Draw the pointer
    _pointer([boxWidth, dimensions.height / 2 - _pointer.width / 2], 'east')
    _path.lineTo(boxWidth, dimensions.height)
    _path.lineTo(0, dimensions.height)
    _path.lineTo(0, 0)
    _path.closePath()

    return _path.toString()
  }

  textContainer (dimensions, handles) {
    const width = dimensions.width * handles[1][0]

    return {
      center: [width / 2, dimensions.center[1]],
      width,
      height: dimensions.height
    }
  }

}
